import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Users } from "../API/Users";
import { Sessions } from "../API/Sessions";
import { useFeedback } from "./useFeedback";
type Auth = {
  logIn: Function | null;
  logOut: Function | null;
  isLogged: boolean;
  user: any;
  isLoading: boolean;
};

const AuthContext = React.createContext<Auth>(null!);
export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }: any) => {
  const auth = usePrivideAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

const permited = ["MASTER", "SELLER"];

const usePrivideAuth = (): Auth => {
  const feedback = useFeedback();
  const userAPI = useMemo(() => new Users(), []);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(null);
  const isLogged = useMemo(() => user != null, [user]);
  const logIn = useCallback(
    async (email: string, password: string) => {
      setIsLoading(true);
      try {
        const response = await userAPI.login({ email, password });
        // check if account has permission to access the CRM
        if (response?.permissions?.length > 0) {
          const userPermissionSet: any = new Set(response.permissions);
          const permitedSet = new Set(permited);
          let intersec: any = userPermissionSet.intersection(permitedSet);
          intersec = Array.from(intersec);
          if (intersec.length > 0) {
            setUser(response);
            setIsLoading(false);
          } else {
            feedback.show({
              type: "warning",
              message: "Account not allowed!",
            });
            userAPI.logout();
          }
        } else {
          feedback.show({
            type: "warning",
            message: "Account not allowed!",
          });
          userAPI.logout();
          setIsLoading(false);

        }
      } catch (error: any) {
        setUser(null);
        setIsLoading(false);
        switch (error.response.status) {
          case 401:
            feedback.show({
              type: "warning",
              message: "Account unauthorized. Check your credentials!",
            });
            break;
          case 403:
            feedback.show({
              type: "warning",
              message: "Account not allowed!",
            });
            break;
          default:
            feedback.show({
              type: "error",
              message: `something went wrong (status: ${error.response.status})`,
            });
        }
      }
    },
    [feedback, userAPI]
  );
  const logOut = useCallback(() => {
    setIsLoading(true);
    userAPI.logout().then(
      (response) => {
        if (response.status === "OK") {
          setUser(null);
          setIsLoading(false);
        }
      },
      (error) => {
        setIsLoading(false);
      }
    );
  }, [userAPI]);
  useEffect(() => {
    const sessionAPI = new Sessions();
    sessionAPI.isValid().then(
      async (response: any) => {
        if (
          response != null &&
          response.id != null
          //   && response["permissions"].length > 0
        ) {
          setUser(response);
        }
      },
      (error) => {
        setUser(null);
      }
    );
  }, [userAPI]);

  return { isLoading, logIn, logOut, user, isLogged };
};
